import React, { Component } from 'react';
import { arrayOf, string, shape, array, bool, func, number, object } from 'prop-types';
import OrgJobList from './OrgJobList/OrgJobList';
import SubHeaderSearch from '../../../JobMatching/ResultDetails/SubHeaderSearch';
import './JobMatchingListPanel.scss';
import { filterSelectedJobs } from '../../../../lib/rulesBasedPricingHelpers';
class JobMatchingListPanel extends Component {
  static propTypes = {
    isSelectAllChecked: bool,
    isSelected: bool,
    orgJobs: array,
    orgJobsTotalCount: number,
    pageOrgJobs: func,
    searchBySelected: func,
    searchCriteria: object,
    selectedJobs: array,
    toggleJobSelected: func,
    toggleSelectAllOrgJobs: func,
    replacementTokens: arrayOf(
      shape({
        token: string,
        value: string
      })
    ),
    useJobCodeKey: bool,
    handlePageChange: func,
    activePage: number
  };
  searchByText = event => {
    const { search, isSelected, searchText } = this.props;
    if (event.keyCode === 13 && isSelected) {
      search(searchText);
    }
  };

  toggleSelectAllFilteredJobs = () => {
    const {
      selectedJobs,
      selectAllFilteredJobs,
      orgJobsTotalCount,
      clearJobsOnly,
      isSelected,
      searchCriteria,
      orgJobs,
    } = this.props;

    const isSelectAllChecked = filterSelectedJobs(orgJobs, selectedJobs).length === orgJobs.length;
    if (isSelectAllChecked && isSelected) {
        clearJobsOnly(orgJobsTotalCount, 0, searchCriteria);
    } else if (!isSelected) {
        clearJobsOnly();
    } else {
        selectAllFilteredJobs(orgJobsTotalCount, 0, searchCriteria);
    }
  };

  clearSearch = () => {
    this.props.search('');
    this.props.setSearchText('');
  };
  render() {
    const {
      isSelectAllChecked,
      isSelected,
      orgJobs,
      orgJobsTotalCount,
      pageOrgJobs,
      searchBySelected,
      searchCriteria,
      selectedJobs,
      toggleJobSelected,
      toggleSelectAllOrgJobs,
      clearSearch,
      searchText,
      setSearchText,
      useJobCodeKey,
      replacementTokens,
      handlePageChange,
      activePage
    } = this.props;
    const selectedJobIds = selectedJobs.map(job => job.orgJobId);
    const filteredJobIds = orgJobs.map(job => job.orgJobId);
    const allSelected = filteredJobIds.filter(id => selectedJobIds.includes(id)).length < filteredJobIds.length;
    
    return (
      <div className="org-jobs__slideout">
        <div className="org-job__list-header">
          <div className="org-job__notes">Select company jobs to apply the rule</div>
          <SubHeaderSearch
            clearSearch={this.clearSearch}
            isSelected={isSelected}
            searchId="org__jobs-search-job-matching-slideout"
            searchByText={this.searchByText}
            searchText={searchText}
            selectedItems={selectedJobs}
            setSearchText={setSearchText}
            toggleSelected={searchBySelected}
            totalCount={orgJobsTotalCount || 0}
            showSelectAllText={allSelected}
            selectAllFilteredJobs={this.toggleSelectAllFilteredJobs}
            showClearLink={selectedJobs.length > 0 && !isSelected}
          />
        </div>
        <OrgJobList
          offset={this.props.offset}
          isSelectAllChecked={isSelectAllChecked}
          isSelected={isSelected}
          orgJobs={orgJobs}
          orgJobsTotalCount={orgJobsTotalCount}
          pageOrgJobs={pageOrgJobs}
          searchCriteria={searchCriteria}
          selectedJobs={selectedJobs}
          toggleJobSelected={toggleJobSelected}
          toggleSelectAllOrgJobs={toggleSelectAllOrgJobs}
          selectAllFilteredJobs={this.toggleSelectAllFilteredJobs}
          replacementTokens={replacementTokens}
          useJobCodeKey={useJobCodeKey}
          handlePageChange={handlePageChange}
          activePage={activePage}
        />
      </div>
    );
  }
}
export default JobMatchingListPanel;
